<template lang="pug">
    div
        script(type="application/ld+json" v-html="schema")
</template>

<script>
import { durationToISO8601 } from '@/helpers/filters'

export default {
    props: {
        video: {
            type: Object,
            required: true,
        },
    },
    computed: {
        schema() {
            const videoObj = this.video
            if (!videoObj) return {}

            const obj = {
                '@context': 'http://schema.org',
                '@type': 'VideoObject',
            }
            if (videoObj.duration) obj.duration = durationToISO8601(videoObj.duration)
            if (videoObj.uploadDate) obj.uploadDate = videoObj.uploadDate
            if (videoObj.title) obj.name = videoObj.title

            if (videoObj.thumbnail)
                obj.thumbnailUrl = this.$getImageUrl(
                    videoObj.thumbnail.key,
                    videoObj.thumbnail.filename
                )

            // doesn't really seem avail for wistia, so this for now
            obj.description = 'a product video'

            if (videoObj.type)
                obj.embedUrl =
                    videoObj.type.toLowerCase() === 'wistia'
                        ? `https://fast.wistia.net/embed/iframe/${videoObj.id}`
                        : `https://www.youtube.com/embed/${videoObj.id}`
            else obj.embedUrl = `https://fast.wistia.net/embed/iframe/${videoObj.id}`

            return JSON.stringify(obj)
        },
    },
    methods: {
        durationToISO8601,
    },
}
</script>
